export enum KeyboardCodeEnum {
  ESC = 'Escape',
  SEPARATOR = 'Separator',
  TAB = 'Tab',
  SPACE = ' ',
  ENTER = 'Enter',
}
